module.exports = __webpack_public_path__ + "img/icon_map_13_off_011.7e6a0257.png";